export const RSA_OAEP_ALGORITHM = {
  name: 'RSA-OAEP',
  modulusLength: 4096,
  publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
  hash: 'SHA-256',
} as const;

export const RSA_OAEP_PARAMS = { name: 'RSA-OAEP', hash: 'SHA-256' } as const;

export const AES_GCM_ALGORITHM = { name: 'AES-GCM', length: 256 } as const;
export const AES_GCM_PARAMS = { name: 'AES-GCM', length: 256 } as const;

export const PBKDF2_ITERATIONS = 100_000;
export const VAULT_SECRET_BYTES = 32;
export const RECOVERY_KEY_BYTES = 32;
export const AES_GCM_IV_BYTES = 12;
export const PBKDF2_SALT_BYTES = 16;
